import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,FormGroup,
  Pagination,
  Modal,
  Tooltip,
  Button
} from "react-bootstrap";
import {GetRiderlocation, getallrider, GetLabRiderlocation} from '../../../Listfunction';
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from 'react-router-dom';
import ReactTable from "react-table";
import LoadingSpinner from 'views/Components/loadingSpinner';
import Datetime from "react-datetime";
import NotificationSystem from 'react-notification-system';
import Card from "components/Card/Card.jsx";
import {style} from "../../../variables/Variables";
import Select from "react-select";
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';

export class Labrider extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            from_date : new Date(),
            to_date : new Date(),
            rider_details : [],
            selected_rider : null,
            selected_riderError : null,
            loading : false,
            noRecordFound :false,
            _notificationSystem: null,
            rider_data:[],
            locationdetails : [],
            bounds_data : null,
            finallat : parseFloat(0),
            finallng : parseFloat(0),
            locationmodal : false,
            paginationData : [],
            nextpage : "",
            prevpage : "",
            currentPage: 1,
            nextdisabled : "1",
            prevdisabled : "1",
            page : 1,
        }
        this.handlesearch = this.handlesearch.bind(this);
    }
    handlefromdate = (date) => {
        this.setState({ from_date:date  });
    }
    handletodate = (date) => {
        this.setState({ to_date:date  });
    }
    openlocation(lati,long)
    {
      this.setState({ locationmodal:true  });
      
      var points_data=[{ lat : parseFloat(lati), lng : parseFloat(long)}]
          this.setState({ finallat:parseFloat(lati) , finallng : parseFloat(long)});
        
    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points_data.length; i++) {
      console.log('hi',points_data[i])
      bounds.extend(points_data[i]);
    }
    console.log(bounds,'bonds')
    this.setState({ bounds_data: bounds });
    }
    closelocationmodal()
    {
      this.setState({ locationmodal:false,bounds_data:null  });
    }
//     handleNetworkError(position)
// {
//   var color = Math.floor((Math.random() * 4) + 1);
//   var level;
//   switch (color) {
//       case 1:
//       level = 'success';
//       break;
//       case 2:
//       level = 'warning';
//       break;
//       case 3:
//       level = 'error';
//       break;
//       case 4:
//       level = 'info';
//       break;
//       default:
//       break;
//   }
//   level = 'error';
//   this.state._notificationSystem.addNotification({
//       title: (<span data-notify="icon" className="pe-7s-gift"></span>),
//       message: (
//           <div>
//                <b>Network Error</b>.
//           </div>
//       ),
//       level: level,
//       position: position,
//       autoDismiss: 15,
//   });
// }
    componentDidMount()
    {
        var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    
    this.setState({_notificationSystem: this.refs.notificationSystem})
    setTimeout(
      function() {
        this.setState({ cardHidden: false }); 
      }.bind(this),
      700
    );
        let role = 7;
    getallrider("", role,obj)
    .then((res) => {
      
      const data = res.data;
      
       var array1 = this.state.rider_details;
       var array2 = array1.concat( data)
      
        this.setState({
          rider_details : array2,
        })
        
        let riderItems = []
                  this.state.rider_details.map((x, i) => {
                    riderItems.push({ value:x.id , label:  x.name })
                  })
                  this.setState({
                    rider_data : riderItems
                  })
    })
        .catch()
        {
            // this.handleNetworkError('bl')

        }
    }
    paginationinfo(url)
    {
      console.log(url ,'page no ')
      this.setState({page:url});
      this.handlesearch();
    }
    handlesearch()
    {
        this.setState({ noRecordFound:false });
        var token = JSON.parse(localStorage.getItem('user'));  
        const  obj = token.token;
        this.setState({ selected_riderError:null  });
        var error = false
        console.log(this.state.selected_rider,'selected rider')
        if(this.state.selected_rider == null)
        {
          error = true
            this.setState({
             selected_riderError: (
                 <small className="text-danger">
                   Please Select Rider
                 </small>
               )
             })
           }else{ this.setState({ selected_riderError: null });}
           if(!error)
           {  
            this.setState({ loading: true }, () => {
        GetLabRiderlocation(this.state.selected_rider.value,this.state.page,obj)
        .then(res=>{
          var data = res.data;
            if(data.data.length == 0)
          {
            this.setState({ noRecordFound : true});  
          }
          var $no_pages = [];
          let serach_string = ""
         for(var i=1;i<=data.last_page;i++)
         {
             
          if(serach_string == "")
          {
           $no_pages.push(i);
          }
          else{
           $no_pages.push(i);
          }
          
         }
    
          if(data.current_page == data.last_page )
         {
          this.setState({ prevdisabled : null});
          this.setState({ nextdisabled : "1"});
         }
         else if(data.current_page == 1 )
         {
          this.setState({ nextdisabled : null});
          this.setState({ prevdisabled : "1"});
         }
         else{
          this.setState({ nextdisabled : null});
          this.setState({ prevdisabled : null});
         }
         if(data.last_page  == 1)
         {
          this.setState({ nextdisabled : 1});
          this.setState({ prevdisabled : 1});
         }
         if(data.length == 0)
         {
           $no_pages = []  
           this.setState({ nextdisabled : 1});
           this.setState({ prevdisabled : 1});
         }
         this.setState({ currentPage : data.current_page});
         if(data.next_page_url != null )
           {
            if(serach_string == "")
            {
             this.setState({ nextpage:data.next_page_url.substring(data.next_page_url.indexOf("=") + 1)});
            }
            else{
             this.setState({ nextpage:data.next_page_url.substring(data.next_page_url.indexOf("=") + 1)});
            }
            
           }
           else{
             this.setState({ nextpage:"#"});
            
           }
           if(data.prev_page_url != null )
           {
            
            if(serach_string == "")
            {
             this.setState({ prevpage:data.prev_page_url.substring(data.prev_page_url.indexOf("?page=") + 1)});
            }
            else{
             this.setState({ prevpage:data.prev_page_url.substring(data.prev_page_url.indexOf("?page=") + 1)});
            }
            
           }
           else{
            
             this.setState({ prevpage:"#"});
            
           }
        
         this.setState({ locationdetails: res.data.data ,paginationData: $no_pages ,loading: false,});

        })
      })
      }
    }
    

    render(){  
    var c = 1;
        return(
            <div className="main-content">
        <Grid fluid>
      <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
            <Card
                
                content={
                <Row>
                <Col md={12}>
                    <Col md={4}>
                    
                    <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Rider"
                          name="selected_rider"
                          value={this.state.selected_rider}
                          onChange={value => this.setState({
                            selected_rider : value
                          })
                          }
                          options={this.state.rider_data}
                        />
                        {this.state.selected_riderError}
                        &nbsp;
                        </Col>
                        <Col md={2}>
                            
                        <Button bsStyle="info" fill  onClick={this.handlesearch} >Search</Button>
                    </Col>
                </Col>
                <Col md={12}>
                  
                  
                  <Table responsive>
                          <thead>
                          <tr>
                            <th>Rider Name </th>
                            <th>Latitude</th>
                            <th>Longitude</th>
                            <th>Date Time</th>
                            <th>location</th>
                          </tr>
                          </thead>
                          <tbody>
                          {this.state.loading ? <tr><td colspan="6"><LoadingSpinner /></td></tr> : 
                          this.state.noRecordFound ? <tr><td colspan="6"><center>No record found</center></td></tr> :
                            <>
                            {this.state.locationdetails.map(s=>(
                              <tr>
                                <td>{this.state.rider_details.map(r=>(
                                  <>
                                  {r.id == s.rider_id?r.name :''}
                                  </>
                                )) }</td>
                                <td>{s.latitude}</td>
                                <td>{s.longitude}</td>
                                <td>{s.created_at}</td>
                                <td><i className="fa fa-map-marker" onClick={this.openlocation.bind(this,s.latitude,s.longitude)} ></i></td>
                              </tr>
                            ))}
                            </>
                            }
                          </tbody>
                  </Table>
                  {
                    this.state.loading ? "" : 
                  this.state.noRecordFound ? "" : 

                    <div style={{textAlign:'center'}}>
                    <Pagination >
                          <Pagination.First onClick={this.paginationinfo.bind(this,this.state.prevpage)} disabled={this.state.prevdisabled} />
                          {this.state.paginationData.map((url) => (
                          <Pagination.Item active={this.state.currentPage==c?"1":null} onClick={ this.paginationinfo.bind(this,url)} >{c++}</Pagination.Item>
                          ))}
                          <Pagination.Last onClick={this.paginationinfo.bind(this,this.state.nextpage)} disabled={this.state.nextdisabled} />
                        </Pagination>
                        </div>
                  }

                   
                  <Modal
              show={this.state.locationmodal}
              onHide={() => this.setState({ locationmodal: true })}
              >
              <Modal.Header >
              <Modal.Title>Rider Location</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <Row>
                    <Col md={15}>
                      <div style={{"height":"260px"}}> 
                      {this.state.locationdetails.length != 0 ?
                <Map className="form-control" style={{"width":'100%'}}
                initialCenter={{
            lat: this.state.finallat,
            lng: this.state.finallng
          }}
          bounds={this.state.bounds_data}
           google={this.props.google} >
                    
                    
                     {this.state.finallat != 0 && this.state.finallng != 0?
                    <Marker   position={{lat:this.state.finallat, lng: this.state.finallng}}
                    name={'Sri Lanka'} />
                    : <Marker   position={{lat:"", lng: ""}}
                    name={'Sri Lanka'} />} 
                    
                    
                    <InfoWindow onClose={this.onInfoWindowClose}>
                        <div>
                        {/* <h1>{this.state.selectedPlace.name}</h1> */}
                        </div>
                    </InfoWindow>
                    </Map>
                    : <h4>Rider Location Not Found </h4>}
                      </div>
                    </Col>
                  </Row>

              </Modal.Body>
              <Modal.Footer>
                <Button bsStyle="danger" onClick={this.closelocationmodal.bind(this)}>Close</Button>
              </Modal.Footer>
              </Modal>
                </Col>
               
                </Row>
                } />
                
            </Col>
          </Row>
        </Grid>
        </div>
        )
    }
}

export default GoogleApiWrapper({
      apiKey: ("AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE")
  })(Labrider)
